<div class="row justify-content-center">
  <div class="col-12 col-xl-10">
    <div class="section-header mb-3 d-flex justify-content-between">
      <h1 class="h5 text-colonial mb-0">{{(isClient || (isIntermediary && client) ? 'Mis pólizas' : 'Seleccione el cliente')}}</h1>
      @if (client){
        <app-client-button [client]="client" (clicked)="client = undefined"></app-client-button>
      }
    </div>
  </div>
</div>
<div class="row justify-content-center">
  <div class="col-12 col-xl-10">
    <div class="card shadow-sm border-0 overflow-hidden rounded-4">
      <shared-table-container>
        @if(isIntermediary && !client){
          <app-client-selector (selectedClient)="handleSelectedClient($event)"></app-client-selector>
        }@else{
          <shared-table
            title="Polizas"
            searchPlaceholder="Buscar pólizas"
            [filters]="typeFilters"
            [(activeFilter)]="activeFilter"
            (filtered)="handleTypeFilter($event)"
            [items]="filteredPolicies"
            [pagination]="pagination"
            [headers]="tableHeaders"
            (searching)="filterPolicies($event)"
            (itemClicked)="showDetails($event)"
            (paginateNext)="paginateNext()"
            (paginatePrev)="paginatePrev()"
          >
            <ng-template sharedTableColumn="policyNumber" let-policyNumber='policyNumber'>
              {{policyNumber | mask: policyMask}}
            </ng-template>
            <ng-template sharedTableColumn="product" let-product='product'>
              <div class="fw-normal d-flex align-items-center text-uppercase gap-3 p-2">
                <span class="material-symbols-outlined fs-1">
                  recent_actors
                </span>
                <span>{{product.description}} </span>
              </div>
            </ng-template>
          </shared-table>
        }
      </shared-table-container>
    </div>
  </div>
</div>
